export default {
  apiBaseUrl: 'https://api.kunagi.fr',
  gtu: 'https://www.kunagi.fr/cgu-mentions-legales-dpa',
  privacy: 'https://www.kunagi.fr/politique-de-confidentialite-app',
  notifications: {
    experienceId: '@yieldstudio/homemeethome',
  },
  login: {
    email: '',
    password: '',
  },
  pusher: {
    host: 'socket.kunagi.fr',
    port: 443,
    key: 'cRtW6RMcQp2HZEuuK4nCDbvyPVVGTce3',
    enabledTransports: ['ws', 'wss'],
    forceTLS: true,
  },
};
